import agent from 'superagent'

const resolveProfileApiUrl = (profileApiUrl) => {
    if (profileApiUrl) return profileApiUrl
    if (!window.phoenix?.serviceBindings?.['profile-url']) {
        throw new Error(
            'Profile API URL should be provided as an argument or set in window.phoenix.serviceBindings but neither were found'
        )
    }
    return `${window.phoenix.serviceBindings['profile-url']}/v3/graphql`
}

const resolveTokenProvider = (tokenProvider) => {
    if (tokenProvider) return tokenProvider
    if (!window.phoenix?.auth?.token) {
        throw new Error(
            'A token provider should be provided as an argument or a token set in window.phoenix.auth.token but neither were found'
        )
    }
    return () => window.phoenix.auth.token
}

const queryProfile = async (queryFn, tokenProvider, profileApiUrl) => {
    const resolvedProfileApiUrl = resolveProfileApiUrl(profileApiUrl)
    const token = await resolveTokenProvider(tokenProvider)()
    const rs = await agent
        .post(resolvedProfileApiUrl)
        .set('Authorization', `Bearer ${token}`)
        .send(queryFn())
    if (rs.body.error) {
        throw new Error(rs.error)
    }
    return rs.body.data
}

export default queryProfile
